import { Routes, Route } from "react-router-dom";
import Layout from "./Layout/Layout";

import SettingsLayout from "./components/Settings/SettingsLayout/SettingsLayout";
import DocumentLibrary from "./pages/Settings/DocumentLibrary/DocumentLibrary";
import DocumentExport from "./pages/Settings/DocumentExport/DocumentExport";

import DocumentReview from "./pages/DocumentReview/DocumentReview";
import UploadPage from "./pages/UploadPage/UploadPage";
import Admin from "./pages/Admin/Admin";
import FileExplorer from "./pages/Settings/FileExplorer/FileExplorer";
import ProtectedRoute from "./components/Routes/ProtectedRoute";

import SignIn from "./pages/SignIn/SignIn";
import LogIn from "./pages/LogIn/LogIn";
import CreateType from "./pages/CreateType/CreateType";
import Departments from "./pages/Settings/Departments/Departments";
import Loader from "./components/Loader/Loader";
import { useContext } from "react";
import { LoaderContext } from "./shared/Contexts/Loader/LoaderContext";
import EditType from "./pages/EditType/EditType";
import GuestRoute from "./components/Routes/GuestRoute";
import RedirectPage from "./pages/RedirectPage";

const AppRoutes = () => {
  const { isLoading } = useContext(LoaderContext);
  return (
    <>
      {isLoading && <Loader />}
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute
              redirectTo="/login"
              element={
                <Layout>
                  <UploadPage />
                </Layout>
              }
            />
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute
              redirectTo="/login"
              element={
                <Layout>
                  <Admin />
                </Layout>
              }
            />
          }
        />
        <Route
          path="/review-document/:documentId"
          element={
            <ProtectedRoute
              redirectTo="/login"
              element={
                <Layout>
                  <DocumentReview />
                </Layout>
              }
            />
          }
        />
        <Route
          path="settings"
          element={
            <ProtectedRoute
              redirectTo="/login"
              element={
                <Layout>
                  <SettingsLayout />
                </Layout>
              }
            />
          }
        >
          <Route
            path="documents-library"
            element={
              <ProtectedRoute
                redirectTo="/login"
                element={<DocumentLibrary />}
              />
            }
          />
          <Route
            path="documents-export"
            element={
              <ProtectedRoute
                redirectTo="/login"
                element={<DocumentExport />}
              />
            }
          />
          <Route
            path="departments"
            element={
              <ProtectedRoute redirectTo="/login" element={<Departments />} />
            }
          />
        </Route>
        <Route
          path="file-explorer"
          element={
            <ProtectedRoute
              redirectTo="/login"
              element={
                <Layout>
                  <FileExplorer />
                </Layout>
              }
            />
          }
        />
        <Route
          path="create-type"
          element={
            <ProtectedRoute
              redirectTo="/login"
              element={
                <Layout>
                  <CreateType />
                </Layout>
              }
            />
          }
        />
        <Route
          path="edit-type/:typeId"
          element={
            <ProtectedRoute
              redirectTo="/login"
              element={
                <Layout>
                  <EditType />
                </Layout>
              }
            />
          }
        />
        <Route path="file/" element={<RedirectPage />} />
        <Route
          path="/login"
          element={<GuestRoute redirectTo="/" element={<LogIn />} />}
        />
        <Route
          path="/signin"
          element={<GuestRoute redirectTo="/" element={<SignIn />} />}
        />
        <Route path="*" element={<div>Not Found</div>} />
      </Routes>
    </>
  );
};

export default AppRoutes;
